module.exports = __webpack_public_path__ + "img/signinthroughsteam.dfcbf539.png";